export default __webpack_public_path__ + "static/media/Luck of the Irish wreath.a606208b.jpg";